import { EndpointBuilder } from "@reduxjs/toolkit/query";
import {
  AccountsTradesStatistics,
  ApiGeneralDataResponse,
  ApiResponse,
  DashboardData,
  TopMarketsData,
} from "@shared/types";

export const dashboardEndpoints = {
  endpoints: (build: EndpointBuilder<any, any, any>) => ({
    getDashboardStats: build.query<AccountsTradesStatistics, void>({
      query: (args) => ({
        url: "get_dashboard_stats/",
        method: "POST",
        body: args,
      }),
      transformResponse: (
        response: ApiResponse<ApiGeneralDataResponse<AccountsTradesStatistics>>
      ) => response.data.data,
    }),
    getTopMarkets: build.query<TopMarketsData, void>({
      query: (args) => ({
        url: "get_top_markets/",
        method: "POST",
        body: args,
      }),
      transformResponse: (
        response: ApiResponse<ApiGeneralDataResponse<TopMarketsData>>
      ) => response.data.data,
    }),
    getDashboardData: build.query<DashboardData, void>({
      query: () => ({
        url: "get_dashboard_data/",
        method: "POST",
      }),
      transformResponse: (
        response: ApiResponse<ApiGeneralDataResponse<DashboardData>>
      ) => response.data.data,
    }),
  }),
};
